import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_attendance_schedule_container = _resolveComponent("attendance-schedule-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-4" }, "月間園児予定", -1)),
    _createVNode(_component_attendance_schedule_container)
  ]))
}